module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Timer-045758d4af14f041d1766f0b6a7e6c59.svg";